import { createSelector } from 'reselect'

import { RootState } from '../accountRoot.reducer'

export const getUserAccount = createSelector(
  (state: RootState) => state.accountsStore.userAccount,
  (state) => state,
)
export const getAllUserAccounts = createSelector(
  (state: RootState) => state.accountsStore.allUserAccounts,
  (state) => state,
)
export const getAllSubsidiaries = createSelector(
  (state: RootState) => state.accountsStore.allSubsidiaries,
  (state) => state,
)
export const onError = createSelector(
  (state: RootState) => state.accountsStore.error,
  (state) => state,
)
export const onSuccess = createSelector(
  (state: RootState) => state.accountsStore.saveSuccess,
  (state) => state,
)
export const getAboSettings = createSelector(
  (state: RootState) => state.accountsStore.aboSettings,
  (state) => state,
)

export const getFacebookConnectHash = createSelector(
  (state: RootState) => state.accountsStore.facebookConnectHash,
  (state) => state,
)

export const getPageIdentifiers = createSelector(
  (state: RootState) => state.accountsStore.pageIdentifiers,
  (state) => state,
)

export const getPageToken = createSelector(
  (state: RootState) => state.accountsStore.token,
  (state) => state,
)
